import { render, staticRenderFns } from "./deInforSettBase.vue?vue&type=template&id=c8a09da2&scoped=true&"
import script from "./deInforSettBase.vue?vue&type=script&lang=js&"
export * from "./deInforSettBase.vue?vue&type=script&lang=js&"
import style0 from "./deInforSettBase.vue?vue&type=style&index=0&id=c8a09da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a09da2",
  null
  
)

export default component.exports